<template>
    <div class="ResetPassword">
        <v-container fill-height class="mainBackG loginMain">
            <v-layout row wrap align-center>
              <v-flex class="text-xs-center" xs12 lg4 style="margin:auto">
                    <!--<v-progress-circular :indeterminate="loading" class="ma-0" color="secondary"-->
                                         <!--height="4"></v-progress-circular>-->
                <div class="Formcard align  no-shadow card-r">
                  <v-form v-model="resetPassword" row class="w-100">
                    <v-flex xs12 md12 pt-0>
                        <v-toolbar flat xs12 class="toolbar ">
                            <div  class="btn-tool">
                            </div>
                            <v-spacer></v-spacer>
                            <v-toolbar-title>
                                <h2 class="textColor text-xs-center title">{{title}}</h2>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items class="hidden-sm-and-down">
                            </v-toolbar-items>
                        </v-toolbar>
                    </v-flex>

                        <v-alert
                                v-if="success && msg"
                                :value="true"
                                color="success"
                                icon="check_circle"
                                outline
                        >
                            {{msg}}
                        </v-alert>
                        <v-progress-circular
                          v-if="loading"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                        <v-alert
                                v-if="!success && msg"
                                :value="true"
                                color="error"
                                icon="warning"
                                outline
                        >
                            {{msg}}
                        </v-alert>
                        <div>
                          <router-link to="/login">
                              <v-btn depressed small color="primary">  visit to login page</v-btn>
                          </router-link>
                        </div>

                        </v-form>
                    </div>
                    <notifications group="error" position="top center"/>

                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>

<script>
  /* eslint-disable */
  import { Store, dispatch, mapState } from 'vuex'

  export default {
  mode:'history',
  name: 'ConfirmMail',
  props:['id'],
  created () {
    this.$store.state.sideNav = false
    var id=this.id
    if(this.$route.name=="confirmation") {
      this.title="Confirmation"
      this.$store.dispatch("confirmMail", id)
      .then(res=>{
        // setTimeout(() => {
            if(res){
                if(res.status_code==200){
                  this.msg="Your email already Confirmed"
                }else if(res.status_code==201){
                  this.success=true
                  this.msg="Confirmation Successfully"
                  setTimeout(() => {
                    router.push = '/login'
                  }, 1000);
                }else{
                  this.msg="Confirmation Failed"
                }
            }
      })

    }else if(this.$route.name=="verification"){
      this.title="Verification"
      this.$store.dispatch("verifyMail", id)
      // .then(res=>{
      //   setTimeout(() => {
      //     if(res.status_code==200){
      //       this.msg="Your email already verified"
      //     }else if(res.status_code==201){
      //       this.success=true
      //       this.msg="Verified Successfully"
      //     }else{
      //       this.msg="Verification Failed"
      //     }
      //   }, 2000);
      // })
    }
    // if(this.$route.name=="")
  },
  computed:{
    ...mapState({
      success: "success",
      msg: "msg"
    }),
  }
}
</script>

<style>
/* .navigation{
  display:none !important
} */
</style>



// WEBPACK FOOTER //
// src/components/ConfirmMail.vue